import React  from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const PaginationSmall = ({  itemsCount, pageSize, currentPage, onPageChange }) => {

    // console.log('Pagination: ', itemsCount,pageSize, currentPage )

    const pagesCount = Math.ceil(itemsCount / pageSize);
    if (pagesCount === 0 || pagesCount === 1) return null;

    const  pages =  _.range(1, pagesCount +1);
    return (
        <div className="pagination small">
            {/*{console.log('pages: ', pages, itemsCount, pageSize, currentPage, onPageChange)}*/}
            {/*<button className={currentPage===1 ? "page muted-text first disabled" : "page first"} onClick = {() => onPageChange(1)}>*/}
            {/*<span className="fas fa-angle-double-left"></span>*/}
            {/*</button>*/}
            { currentPage === 1 ?
                <button className={ "page muted-text disabled"}>
                    <span className="fas fa-angle-left"></span>
                </button>
                :
                <button
                    className={ "page" }
                    onClick = {() => onPageChange((currentPage-1)>1 ? currentPage-1 : 1)}>
                        <span className="fas fa-angle-left"></span>
                </button>
            }
            {pages.map((page, index) => (
                <button className={page===currentPage ? "page active" : "page muted-text"}
                        key={index}
                    // onClick = {() => onPageChange(page)}
                        style={(((currentPage>1) && (page+1)===currentPage) || ((currentPage>2) && (page+2)===currentPage) ||
                            page === currentPage || (page - 1) === currentPage || (page - 2) === currentPage ||
                            (page === (pagesCount-3) && pagesCount === currentPage ) || (page === (pagesCount-4) && pagesCount === currentPage ) ||
                            (page === (currentPage-3) && ((pagesCount-1) === currentPage) || (page === 4) && (currentPage === 1) ||
                                (page === 5) && (currentPage === 1) || ((page ===  5) && (currentPage === 2)) )) ?
                            {} : {display: "none"}}> {page}
                </button>
            ))
            }

            { currentPage === pagesCount ?
                <button className={ "page muted-text disabled"}>
                    <span className="fas fa-angle-right"></span>
                </button>
                :
                <button
                    className={ "page" }
                    onClick={ () => onPageChange((currentPage + 1) < pagesCount ? currentPage + 1 : pagesCount) }>
                    <span className="fas fa-angle-right"></span>
                </button>
            }
            {/*<button className={currentPage===pagesCount ? "page muted-text disabled" : "page last"}*/}
            {/*onClick = {() => onPageChange(pagesCount)}>*/}
            {/*<span className="fas fa-angle-double-right"></span>*/}
            {/*</button>*/}
        </div>
    );
};


PaginationSmall.propTypes = {
    itemsCount: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired
};

export default PaginationSmall;
